<template>
	<div>
		<modal
			v-if="modalOpen"
			class="saved-info"
			ref="modal"
			:has-scroll-to-top="true"
			:indent="true"
		>
			<div class="modal__inner saved-info__inner">
				<div class="saved-info__header">
					<h2 class="saved-info__heading">
						<svg svg-inline="" focusable="false" role="presentation" height="141.732" viewBox="-1.23 -8.789 141.732 141.732" width="141.732" xmlns="http://www.w3.org/2000/svg"><path fill="#737a85" d="M139.273 49.088c0-3.284-2.75-5.949-6.146-5.949-.219 0-.434.012-.646.031l-42.445-1.001-14.5-37.854C74.805 1.824 72.443 0 69.637 0c-2.809 0-5.168 1.824-5.902 4.315L49.232 42.169 6.789 43.17a6.606 6.606 0 0 0-.646-.031C2.75 43.136 0 45.802 0 49.088c0 2.1 1.121 3.938 2.812 4.997l33.807 23.9-12.063 37.494a5.728 5.728 0 0 0-.688 2.723c0 3.287 2.75 5.952 6.146 5.952a6.236 6.236 0 0 0 3.812-1.29l35.814-22.737 35.812 22.737a6.236 6.236 0 0 0 3.812 1.29c3.393 0 6.143-2.665 6.143-5.952 0-.979-.25-1.906-.688-2.723l-12.062-37.494 33.806-23.9c1.687-1.061 2.81-2.9 2.81-4.997"/></svg>
						<span>My Saved Info</span>
					</h2>
					<p>This is where all your saved information lives.</p>

					<content-toggle
						:is-preview.sync="isPreview"
					/>
				</div>

				<saved-info-instruction
					:is-preview="isPreview"
				/>

				<div class="saved-info__listing">
					<div v-if="$store.state.savedContent.length < 1">
						You don't have any saved content yet.
					</div>

					<saved-content-listing
						v-for="(content, index) in $store.state.save.content"
						:key="index"
						:index="index"
						:content="content"
						:is-preview="isPreview"
						:remove-save="remove"
						:total="$store.state.save.content.length"
					/>
				</div>

			</div>

			<template slot="modalFooter">
				<div class="footer-cta footer-cta--sticky">
					<div class="btn-row btn-row--equal-2">
						<button
							type="button"
							@click="modalOpen = false"
							class="btn--secondary"
						>
							Close
						</button>
						<a
							href="#"
							@click.space.enter.prevent="share"
							class="btn btn--border"
							:class="{ 'btn--disabled': !$store.state.save || $store.state.save.content.length <= 0 }"
						>
							Share
						</a>
					</div>
				</div>
			</template>

			<confirmation
				v-if="confirmationOpen"
				heading="Are you sure you want to remove this information?"
				confirm-text="I'm sure"
				:confirm-method="removeSave"
				:confirm-method-params="confirmationRemoveIds"
				close-text="Cancel"
				:close-method="confirmationClose"
			>
				If you remove this information and then change your mind, you'll need to re-add again later.
			</confirmation>
		</modal>
		<div v-if="modalOpen" class="overlay"></div>
	</div>
</template>

<script>
// Mixins
import { saves } from '@/mixins/saves.js';

// Styles
import '@/sass/components/_saved-info.scss';

// Components
import Modal from '@/components/global/Modal.vue';
import SavedContentListing from '@/components/blocks/SavedContentListing.vue';
import ContentToggle from '@/components/blocks/ContentToggle.vue';
import SavedInfoInstruction from '@/components/blocks/SavedInfoInstruction.vue';
import Confirmation from '@/components/global/Confirmation.vue';

export default {
	mixins: [saves],
	components: {
		Modal,
		SavedContentListing,
		ContentToggle,
		SavedInfoInstruction,
		Confirmation
	},
	data() {
		return {
			isPreview: true,
			confirmationOpen: false
		};
	},
	computed: {
		modalOpen: {
			get() {
				return this.$store.state.modalsVisible.savedInfo;
			},
			set(value) {
				this.$store.commit('modalVisible', {
					modal: 'savedInfo',
					boolean: value
				});
			}
		}
	},
	watch: {
		modalOpen(val) {
			this.$eventBus.$emit('checkAllSaved');

			if (val === false && this.$route.name === this.$GLOBALS.ROUTE_SHARE_CONTENT) {
				this.$eventBus.$emit('generatePdf');
			}
		}
	},
	methods: {
		share() {
			if (this.$store.state.save && this.$store.state.save.content.length > 0) {
				this.modalOpen = false;

				this.$nextTick(() => {
					this.$router.push({
						name: this.$GLOBALS.ROUTE_SHARE_CONTENT
					});
				});
			}
		},
		confirmationClose() {
			this.confirmationOpen = false;
		},
		previewToggle(bool) {
			this.isPreview = bool;
		}
	},
	mounted() {
		this.$eventBus.$on('previewToggle', this.previewToggle);
		this.isPreview = true;
	}
};
</script>
